import { useQuery } from '@apollo/client';
import {
  GET_LIMITS_LIST,
  LimitsListResponse,
  mapLimitsList,
} from '@/features/Profile/sections/Limits/api';

export function useLimitsList() {
  const { data, loading } = useQuery<LimitsListResponse>(GET_LIMITS_LIST, {
    fetchPolicy: 'cache-and-network',
  });

  const limits = mapLimitsList(data?.currentUserAdsLimits ?? []);

  return {
    loading,
    limits,
    hasLimits: limits.length > 0,
  };
}
